import { ImageContainer } from "./styles";

const Item = ({ item, handleClick }) => {
  const details = Object.entries(item.details || {}) || [];

  if (!item || !item.product_id) return null;

  return (
    <div
      className={[
        `beon-showcase__item`,
        `beon-interaction__item`,
        item?.is_available ? `bn-available` : `bn-unavailable`,
      ].join(` `)}
      data-product-id={item?.product_id}
      data-product-sku={item?.sku}
      data-product-extra='["", ""]'
      onClick={(e) => handleClick(item, e)}
    >
      <div className="beon-showcase__item-title">
        <a
          href={item?.url}
          title={item?.name}
          data-action="details"
          data-track="click"
          data-event='["Detalhes", null, null]'
          data-bind="true"
        >
          <span>{item?.name}</span>
        </a>
      </div>
      <ul className="beon-showcase__item-details">
        {details?.map((detail) => (
          <li
            key={`detail-${detail[0]}`}
            className={`detail-${detail[0]}`}
            data-value={detail[1]}
          >
            {detail[1]}
          </li>
        ))}
      </ul>
      <div className="beon-showcase__item-references">
        <span className="beon-product__sku">{item.sku}</span>{" "}
        <span className="beon-product__id">{item.product_id}</span>
      </div>
      <div className="beon-showcase__item-tags"></div>
      <div className="beon-showcase__review">
        <div
          className="bn--widget bn--yourviews yv-review-quickreview"
          value={item.product_id}
          style={{ display: "block" }}
        ></div>
        <div
          className="bn--widget bn--trustvox"
          data-trustvox-product-code={item.product_id}
          style={{ display: "none" }}
        ></div>
      </div>

      <ImageContainer className="beon-showcase__item-image">
        <a
          href={item?.url}
          title={item?.name}
          data-action="details"
          data-track="click"
          data-event='["Detalhes", null, null]'
          data-bind="true"
        >
          {item?.images?.map((imageUrl, i) => (
            <img
              key={crypto.randomUUID()}
              alt={item?.name}
              className={`bn-lazy  ${
                i === 1 ? "bn-hover" : i > 1 ? "bn-hover hidden" : ""
              }`}
              onLoad={({ target }) => target.classList.add("loaded")}
              src={imageUrl}
            />
          ))}
        </a>
      </ImageContainer>

      <div className="beon-showcase__item-description">
        {item?.price_to > 0 && (
          <div
            className={`beon-showcase__item-price-box beon-showcase__item-price-box--${
              item?.is_promo ? "special" : "simple"
            }`}
          >
            {item?.price_from > 0 && item?.is_promo && (
              <span className="beon-showcase__item-price beon-showcase__item-price--from">
                <span className="prefix">De:</span>
                <span className="beon-showcase__price">
                  <span className="currency">R$ </span>
                  <span className="value">
                    {(item?.price_from).toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                    })}
                  </span>
                </span>
              </span>
            )}

            <span className="beon-showcase__item-price beon-showcase__item-price--to">
              <span className="prefix"> por: </span>{" "}
              <span className="beon-showcase__price">
                <span className="currency">R$ </span>
                <span className="value">
                  {(item?.price_to).toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                  })}
                </span>
              </span>
            </span>
            {item?.installment_amount > 0 && (
              <span className="beon-showcase__item-installments">
                <span className="null"> ou </span>{" "}
                <strong className="beon-interaction__installmentsCount">
                  {" "}
                  {item?.installment_months}x{" "}
                </strong>{" "}
                <span className="null"> de </span>
                <strong className="beon-interaction__installmentPrice">
                  {" "}
                  <span className="currency">R$ </span>
                  <span className="value">
                    {(item?.installment_amount).toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                    })}
                  </span>{" "}
                </strong>
              </span>
            )}
            {item?.additional_prices && item?.additional_prices?.avista && (
              <span className="beon-showcase__item-avista">
                {" "}
                <strong className="beon-showcase__item-price">
                  {" "}
                  <span className="currency">R$ </span>
                  <span className="value">
                    {(item?.additional_prices?.avista).toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                    })}
                  </span>{" "}
                </strong>{" "}
              </span>
            )}
          </div>
        )}
      </div>

      <div className="beon-showcase__item-badges">
        {item.is_promo && (
          <span className="beon-showcase__item-badge beon-showcase__item-badge--off">
            <span className="beon-showcase__item-discount">
              {item?.price_discount_off}%
            </span>
            <span className="null">off</span>
          </span>
        )}
        {item.is_promo && (
          <span className="beon-showcase__item-badge beon-showcase__item-badge--off beon-showcase__item-badge--off-value">
            <span className="beon-showcase__item-discount">
              {item?.price_discount_off}
            </span>
          </span>
        )}

        <span
          className={`beon-showcase__item-badge beon-showcase__item-badge--${
            item?.is_available ? `available` : `unvailable`
          }`}
        >
          <span>
            {item?.is_available ? `Entrega imediata` : `Produto indisponível`}
          </span>
        </span>

        {item?.is_new && (
          <span className="beon-showcase__item-badge beon-showcase__item-badge-new">
            <span>Lançamento</span>{" "}
          </span>
        )}

        {
          // Not available on API - @TODO
          item?.free_shipping_price > 0 &&
            item?.free_shipping_price < item?.price_to && (
              <span className="beon-showcase__item-badge beon-showcase__item-badge--shipping">
                {" "}
                <span>Frete grátis</span>{" "}
              </span>
            )
        }
      </div>

      <div className="beon-showcase__item-actions beon-showcase__item-actions--search">
        {item?.search_strategies?.join(", ")}
      </div>

      <div className="beon-showcase__item-actions beon-showcase__item-actions--search">
        <a
          href={`/checkout/cart/add?sku=${item?.sku}&qty=1`}
          className="beon-button beon-button--primary"
          data-action="buy"
          data-track="click"
          data-event='[\"Comprar\", null, null]'
          style={{ display: "none" }}
        >
          {" "}
          <span className="beon-button__label beon-button__label--buy">
            Comprar
          </span>
        </a>
        <a
          href={item?.url}
          className="beon-button beon-button--primary"
          data-action="details"
          data-track="click"
          data-event='["Detalhes", null, null]'
          data-bind="true"
        >
          <span className="beon-button__label beon-button__label--details">
            Ver detalhes
          </span>
        </a>
      </div>
    </div>
  );
};

export default Item;
